import { CALL_API } from 'redux-api-middleware';
import { handleActions } from 'redux-actions';
import { validate } from '../../middleware/validator';
import { ROUTE } from '../../middleware/route';
import paths from '../../../routes/paths';
import * as av from './actionvalidators';
import { USER_API } from '../../../../config/endpoints';
import * as fromAuth from '../auth';

export const SET_PASSWORD_AND_CONFIRM = 'SIGNUP/SET_PASSWORD_AND_CONFIRM';
export const SET_PASSWORD_AND_CONFIRM_ERROR =
  'SIGNUP/SET_PASSWORD_AND_CONFIRM_ERROR';

export const SAVE_PASSWORD = Symbol('SAVE_PASSWORD');
export const SAVE_PASSWORD_REQUEST = 'USER/SAVE_PASSWORD_REQUEST';
export const SAVE_PASSWORD_FAILURE = 'USER/SAVE_PASSWORD_FAILURE';
export const SAVE_PASSWORD_RECEIVE = 'USER/SAVE_PASSWORD_RECEIVE';

// ACTION CREATORS
const savePassword = (email, password) => ({
  [CALL_API]: {
    endpoint: `${USER_API}/v3/password`,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      password,
    }),
    types: [
      SAVE_PASSWORD_REQUEST,
      {
        type: SAVE_PASSWORD_RECEIVE, [ROUTE]: paths.signup.passwordsuccess,
      },
      { type: SAVE_PASSWORD_FAILURE },
    ],
    options: { addAuth: true },
  },
});

// const setPasswordAndConfirmSuccess = (password, confirmPassword) => ({
//   type: SET_PASSWORD_AND_CONFIRM,
//   password,
//   confirmPassword,
//   [ROUTE]: paths.signup.passwordsuccess,
// });

const setPasswordAndConfirmFailure = (password, confirmPassword) => ({
  type: SET_PASSWORD_AND_CONFIRM_ERROR,
  password,
  confirmPassword,
  [ROUTE]: paths.signup.password,
});

export const setPasswordAndConfirm = (password, confirmPassword, { auth }) => {
  const email = fromAuth.getEmail(auth);

  return {
    [validate]: {
      validator: () =>
        av.validatePassword(password).result &&
        av.validateConfirmPassword(password, confirmPassword).result,
      success: savePassword(email, password),
      fail: setPasswordAndConfirmFailure(password, confirmPassword),
    },
  };
};

/** selector */
export const getPassword = (state) => state.password;
export const getPasswordError = (state) => state.passwordError;
export const getConfirmPassword = (state) => state.confirmPassword;
export const getConfirmPasswordError = (state) => state.confirmPasswordError;

/**  reducer & action */
export const password = handleActions(
  {
    [SET_PASSWORD_AND_CONFIRM]: (state, action) => action.password,
  },
  null
);

export const confirmPassword = handleActions(
  {
    [SET_PASSWORD_AND_CONFIRM]: (state, action) => action.confirmPassword,
  },
  null
);

export const passwordError = handleActions(
  {
    [SET_PASSWORD_AND_CONFIRM]: () => null,
    [SET_PASSWORD_AND_CONFIRM_ERROR]: (state, action) =>
      av.validatePassword(action.password).message || null,
  },
  null
);

export const confirmPasswordError = handleActions(
  {
    [SET_PASSWORD_AND_CONFIRM]: () => null,
    [SET_PASSWORD_AND_CONFIRM_ERROR]: (state, action) =>
      av.validateConfirmPassword(action.password, action.confirmPassword)
        .message || null,
  },
  null
);
